import CameraControls from './CameraControls';
import CameraStatus from './CameraStatus';
import CameraZoomControl from './CameraZoomControl';
import ManualPlateButton from './ManualPlateButton';

export default function CameraViewport({ camera, onCapture, onSelectGallery, onManualEntry }) {
  return <section className="plate-camera" aria-label="نمای دوربین">
    <video ref={camera.videoRef} className="plate-camera__video" autoPlay muted playsInline />

    <ManualPlateButton onClick={onManualEntry} />
    <CameraStatus status={camera.status} error={camera.error} onRetry={camera.start} />
    <CameraZoomControl visible={camera.status === 'ready'} range={camera.zoomRange} value={camera.zoom} onChange={camera.setZoom} />
    <CameraControls status={camera.status} onCapture={onCapture} onSwitchCamera={camera.switchCamera} onSelectGallery={onSelectGallery} />
  </section>;
}
